/**
 * SonnBrand.ts — raw DOM brand elements for the Sonn chat panel.
 * No JSX, no framework — returns HTMLElement / SVGSVGElement directly.
 */

export function createSonnNote(color = 'var(--acc)', glow = true): SVGSVGElement {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '-2 -38 24 44');
    svg.style.cssText = [
        'position:absolute',
        'bottom:0.04em',
        'left:0',
        'width:100%',
        'height:auto',
        'overflow:visible',
        glow ? `filter:drop-shadow(0 0 6px ${color})` : '',
        'opacity:0.98',
    ].filter(Boolean).join(';');

    const ellipse = document.createElementNS(ns, 'ellipse');
    ellipse.setAttribute('cx', '6');
    ellipse.setAttribute('cy', '0');
    ellipse.setAttribute('rx', '6.2');
    ellipse.setAttribute('ry', '4.7');
    ellipse.setAttribute('transform', 'rotate(-22 6 0)');
    ellipse.setAttribute('fill', color);

    const stem = document.createElementNS(ns, 'path');
    stem.setAttribute('d', 'M 11.4 -3 L 13.6 -32');
    stem.setAttribute('stroke', color);
    stem.setAttribute('stroke-width', '1.8');
    stem.setAttribute('stroke-linecap', 'round');
    stem.setAttribute('fill', 'none');

    const flag = document.createElementNS(ns, 'path');
    flag.setAttribute('d', 'M 13.6 -32 Q 20 -27, 17 -20');
    flag.setAttribute('stroke', color);
    flag.setAttribute('stroke-width', '1.8');
    flag.setAttribute('stroke-linecap', 'round');
    flag.setAttribute('fill', 'none');

    svg.appendChild(ellipse);
    svg.appendChild(stem);
    svg.appendChild(flag);
    return svg;
}

export function createSonnWordmark(): HTMLSpanElement {
    const wrapper = document.createElement('span');
    wrapper.className = 'sonn-wordmark';
    wrapper.style.cssText = 'display:inline-flex;align-items:baseline;font-size:26px';

    const text = document.createTextNode('sonn');
    wrapper.appendChild(text);

    const noteWrapper = document.createElement('span');
    noteWrapper.style.cssText = [
        'display:inline-block',
        'width:0.34em',
        'height:1em',
        'vertical-align:baseline',
        'position:relative',
        'margin-left:0.02em',
        'font-family:var(--f-display)',
    ].join(';');
    noteWrapper.appendChild(createSonnNote());
    wrapper.appendChild(noteWrapper);
    return wrapper;
}

export function createSonnGlyph(size = 24): HTMLSpanElement {
    const ns = 'http://www.w3.org/2000/svg';
    const wrapper = document.createElement('span');
    wrapper.style.cssText = [
        `width:${size}px`,
        `height:${size}px`,
        'background:var(--bg-elev)',
        `border-radius:${Math.round(size * 0.22)}px`,
        'display:inline-flex',
        'align-items:center',
        'justify-content:center',
        'border:1px solid var(--line)',
        'position:relative',
        'overflow:hidden',
        'flex-shrink:0',
    ].join(';');

    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.style.cssText = 'width:74%;height:74%';

    const text = document.createElementNS(ns, 'text');
    text.setAttribute('x', '22');
    text.setAttribute('y', '78');
    text.setAttribute('font-family', "'Instrument Serif', Georgia, serif");
    text.setAttribute('font-style', 'italic');
    text.setAttribute('font-size', '92');
    text.setAttribute('fill', 'var(--text)');
    text.setAttribute('letter-spacing', '-2');
    text.textContent = 's';

    const head = document.createElementNS(ns, 'ellipse');
    head.setAttribute('cx', '62');
    head.setAttribute('cy', '74');
    head.setAttribute('rx', '9');
    head.setAttribute('ry', '6.8');
    head.setAttribute('transform', 'rotate(-22 62 74)');
    head.setAttribute('fill', 'var(--acc)');

    const stem = document.createElementNS(ns, 'path');
    stem.setAttribute('d', 'M 70.5 70 L 74 26');
    stem.setAttribute('stroke', 'var(--acc)');
    stem.setAttribute('stroke-width', '3.2');
    stem.setAttribute('stroke-linecap', 'round');
    stem.setAttribute('fill', 'none');

    const flag = document.createElementNS(ns, 'path');
    flag.setAttribute('d', 'M 74 26 Q 86 33, 80 46');
    flag.setAttribute('stroke', 'var(--acc)');
    flag.setAttribute('stroke-width', '3.2');
    flag.setAttribute('stroke-linecap', 'round');
    flag.setAttribute('fill', 'none');

    svg.appendChild(text);
    svg.appendChild(head);
    svg.appendChild(stem);
    svg.appendChild(flag);
    wrapper.appendChild(svg);
    return wrapper;
}
